import { render, staticRenderFns } from "./AdminFaq.vue?vue&type=template&id=5fd83bc0"
import script from "./AdminFaq.vue?vue&type=script&lang=js"
export * from "./AdminFaq.vue?vue&type=script&lang=js"
import style0 from "./AdminFaq.vue?vue&type=style&index=0&id=5fd83bc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports